<ng-container *ngIf="isFocused">
  <app-genesys-chat-file-upload-box
    [fileUploadState]="fileUploadState$ | async"
    (deleteFile)="deleteFile()"
    (sendMedia)="onMediaSend($event)"
  >
  </app-genesys-chat-file-upload-box>
  <ng-container *ngIf="settings$ | async as settings">
    <app-genesys-editor
      *ngIf="isEditorVisible && !isConversationAcceptable"
      [(editorContent)]="editorContent.html"
      [submitOnEnter]="true"
      [contentFormat]="settings.contentFormat"
      [editorSettings]="settings.editorSettings"
      [showFileUpload]="true"
      [editorDisabled]="isMessagingPeriodEnded"
      [placeholder]="'gcChatFooter.editorPlaceholder' | translate"
      [isUrlImagesEnabled]="isUrlImagesEnabled$ | async"
      (init)="onEditorInitialized()"
      (submit)="onEditorSubmit($event, settings.richTextEnabled)"
      (fileSelected)="uploadFile($event)"
      [fileSelectionDisabled]="!!(fileUploadState$ | async).file"
      (editorContentChange)="setTyping()"
    ></app-genesys-editor>
  </ng-container>

  <ng-container *ngIf="!isWrapUpVisible; else wrapUpPanelTpl">
    <div class="row" *ngIf="isExpandedMode; else narrowModePanelTpl">
      <app-genesys-chat-buttons
        [isExpandedMode]="isExpandedMode"
        [disableButtons]="isConversationAcceptable"
        [isCobrowseActive]="isCobrowseActive"
        (endChat)="endOrShowConfirmation()"
        (sendWrapUp)="toggleWrapUps()"
        (openTransferPanel)="onTransferPanelOpen()"
      >
      </app-genesys-chat-buttons>
    </div>

    <ng-template #narrowModePanelTpl>
      <app-more-actions-panel
        [isOpen]="isMoreActionsVisible"
        [openFocusTarget]="focusTarget"
        (togglePanel)="toggleMoreActions()"
      >
        <app-genesys-chat-buttons
          #focusTarget
          [isExpandedMode]="isExpandedMode"
          [disableButtons]="isConversationAcceptable"
          (endChat)="endOrShowConfirmation()"
          (sendWrapUp)="toggleWrapUps()"
          (openTransferPanel)="onTransferPanelOpen()"
        >
        </app-genesys-chat-buttons>
      </app-more-actions-panel>
    </ng-template>
  </ng-container>

  <ng-template #wrapUpPanelTpl>
    <app-genesys-wrapup-panel
      class="footer-panel-top-border"
      [disableButtons]="isConversationAcceptable"
      [conversationId]="conversationId"
      [selectedWrapUp]="selectedWrapUpCode"
      [wrapUpCodes]="wrapUpCodes$ | async"
      [isWrapUpRequired]="isWrapUpRequired"
      [isConversationClosed]="!isConversationOpen"
      [communicationType]="communicationTypes.Message"
      (selected)="selectWrapUp($event)"
      (submitted)="saveWrapUp($event)"
      (skipped)="skipWrapUp()"
      (togglePanel)="toggleWrapUps()"
    >
    </app-genesys-wrapup-panel>
  </ng-template>
</ng-container>

<app-auto-save
  [model]="editorContent"
  [storageKey]="autoSaveStorageKey"
  (modelChange)="onAutoSaveModelChange($event)"
></app-auto-save>

<app-confirmation-modal
  *ngIf="!isConfirmationModalDisabled && confirmationVisible"
  [config]="confirmationBoxConfig"
  (cancel)="closeConfirmation()"
  (confirm)="onConversationEnded()"
  (secondaryAction)="endConversationAndTurnOffModal()"
>
</app-confirmation-modal>
